import { combineReducers } from 'redux';
import { enableMapSet } from 'immer';

import onboarding from 'src/features/onboarding/slice';
import filterBy from 'src/features/overview/filterBy/slice';
import performance from 'src/features/overview/performance/slice';
import sourceOfLeads from 'src/features/overview/sourceOfLeads/slice';
import leadResults from 'src/features/overview/leadResults/slice';
import callActivity from 'src/features/overview/callActivity/slice';
import upcomingCalls from 'src/features/overview/upcomingCalls/slice';
import avgSpeed from 'src/features/overview/avgSpeed/slice';
import leadResponse from 'src/features/overview/leadResponse/slice';
import parkedCalls from 'src/features/overview/parkedCalls/slice';
import activeCalls from 'src/features/overview/activeCalls/slice';

import firstAttempt from 'src/features/insights/firstAttempt/slice';
import percentOfConnections from 'src/features/insights/percentOfConnections/slice';
import noConnections from 'src/features/insights/noConnections/slice';
import leadCall from 'src/features/insights/leadCall/slice';
import newLeadFlow from 'src/features/insights/newLeadFlow/slice';
import highestConnections from 'src/features/insights/highestConnections/slice';

import filterByG from 'src/features/groupPerformance/filterBy/slice';
import callAttempt from 'src/features/groupPerformance/callAttempt/slice';
import connectedCalls from 'src/features/groupPerformance/connectedCalls/slice';
import callDuration from 'src/features/groupPerformance/callDuration/slice';

import filterByC from 'src/features/callRecordings/filterBy/slice';
import calls from 'src/features/callRecordings/calls/slice';

import parkedCallsPage from 'src/features/parkedCalls/slice';

import groupsList from 'src/features/routingRules/groupsList/slice';
import createGroup from 'src/features/routingRules/createGroup/slice';

import blackoutDays from 'src/features/advanceSettings/blackoutDays/slice';
import tags from 'src/features/advanceSettings/tags/slice';

enableMapSet();

export default combineReducers({
  onboarding,
  me: combineReducers({
    overview: combineReducers({
      filterBy,
      performance,
      sourceOfLeads,
      leadResults,
      callActivity,
      upcomingCalls,
      avgSpeed,
      leadResponse,
      parkedCalls,
      activeCalls,
    }),
    insights: combineReducers({
      firstAttempt,
      percentOfConnections,
      noConnections,
      leadCall,
      newLeadFlow,
      highestConnections,
    }),
    groupPerformance: combineReducers({
      filterBy: filterByG,
      callAttempt,
      connectedCalls,
      callDuration,
    }),
    callRecordings: combineReducers({
      filterBy: filterByC,
      calls,
    }),
    parkedCallsPage,
    routingRules: combineReducers({
      groupsList,
      createGroup,
    }),
    advanceSettings: combineReducers({
      blackoutDays,
      tags,
    }),
  }),
});
